import React, { useEffect, useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { formattedCurrency } from "../../utils/helpers/calculateTime";
import "../../assets/styles/local/AddProduct.css";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";

const PartStock = ({
  stockData,
  setStockData,
  productionHistory,
  productList,
  minMaxError,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const calculatePagination = (pageNumber) => {
    let records = productionHistory || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(5 * pageNumber - 4, 1),
      endRecordIndex: Math.min(5 * pageNumber, records.length),
      totalPages: Math.ceil(records.length / 5),
      records: records?.slice((pageNumber - 1) * 5, pageNumber * 5),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [productionHistory]);

  const handleValorizationChange = (e) => {
    const { name, checked } = e.target;
    setStockData((prevState) => ({
      ...prevState,
      isFifo: name === "isFifo" ? checked : false,
      isLifo: name === "isLifo" ? checked : false,
      isAverage: name === "isAverage" ? checked : false,
    }));
  };

  return (
    <div className="pt-4 addproduct_stock_tab">
      <div className="row col-12 p-0 m-0">
        <div className="col-2  p-0 m-0">
          <div className="products-and-parts-toggle-area">
            <label>{t("Stock Management")}</label>
            <input
              type="checkbox"
              id="products-and-parts-switch2"
              className="checkbox"
              name="stockmanagement"
              checked={stockData?.enableStockManagement}
              value={stockData?.enableStockManagement}
              onChange={(e) =>
                setStockData((prevData) => ({
                  ...prevData,
                  enableStockManagement: e.target.checked,
                }))
              }
            />
            <label
              htmlFor="products-and-parts-switch2"
              className="toggle"
            ></label>
          </div>
          {stockData?.enableStockManagement && (
            <div className="d-flex gap-2 align-items-center">
              <div
                className="products-and-parts-asc-input-container"
                id="products-and-parts-ascInput"
              >
                <label
                  className={
                    minMaxError
                      ? "errorLabel products-and-parts-asc-label-top products-and-parts-item-id-title"
                      : "products-and-parts-asc-label-top products-and-parts-min-max-title"
                  }
                >
                  {/* Min */}
                  {t("Min")}
                </label>
                <input
                  type="number"
                  className={
                    minMaxError
                      ? "product-input-error products-and-parts-stock-inputs products-and-parts-min-max-input"
                      : "products-and-parts-stock-inputs products-and-parts-min-max-input"
                  }
                  placeholder="0"
                  value={stockData.minimum}
                  name="minimum"
                  onChange={(e) =>
                    setStockData((prevData) => ({
                      ...prevData,
                      minimum: e.target.value,
                    }))
                  }
                />
              </div>
              <div
                className="products-and-parts-asc-input-container"
                id="products-and-parts-ascInput"
              >
                <label
                  className={
                    minMaxError
                      ? "errorLabel products-and-parts-asc-label-top products-and-parts-item-id-title"
                      : "products-and-parts-asc-label-top products-and-parts-min-max-title"
                  }
                >
                  {/* Max */}
                  {t("Max")}
                </label>
                <input
                  type="number"
                  className={
                    minMaxError
                      ? "product-input-error products-and-parts-stock-inputs products-and-parts-min-max-input"
                      : "products-and-parts-stock-inputs products-and-parts-min-max-input"
                  }
                  placeholder="0"
                  value={stockData.maximum}
                  name="maximum"
                  onChange={(e) =>
                    setStockData((prevData) => ({
                      ...prevData,
                      maximum: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
          )}
        </div>
        <div className="col-10 row  p-0 m-0 justify-content-end">
          {stockData?.enableStockManagement && (
            <>
              <div className="position-relative col-6" id="ascInput">
                <label className="asc-label-top product-stock-title">
                  {/* Stock Valorization */}
                  {t("Stock Valorization")}
                </label>
                <div className="contactInput flex-row justify-content-center">
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isFifo}
                      name="isFifo"
                      checked={stockData.isFifo}
                      onChange={handleValorizationChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* FIFO (First in First out) */}
                      {t("FIFO")} {t("(First In First Out)")}
                    </span>
                  </div>
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isLifo}
                      name="isLifo"
                      checked={stockData.isLifo}
                      onChange={handleValorizationChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* LIFO (Last in First out) */}
                      {t("LIFO")} {t("(Last In First Out)")}
                    </span>
                  </div>
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isAverage}
                      name="isAverage"
                      checked={stockData.isAverage}
                      onChange={handleValorizationChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* Average */}
                      {t("Average")}
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="position-relative col-6" id="ascInput">
            <label className="asc-label-top product-stock-title">
              {/* Stock Value(YTD) */}
              {t("Stock Value")}
              {t("(YTD)")}
            </label>
            <div className="contactInput justify-content-center">
              <div
                className="under-Texts "
                style={{
                  justifyContent: !stockData?.enableStockManagement
                    ? "end"
                    : "space-around",
                  paddingRight: !stockData?.enableStockManagement ? "15px" : "",
                }}
              >
                {stockData?.enableStockManagement && (
                  <>
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* Total Cost */}
                      {t("Total Cost")}
                    </span>
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* Unit Cost */}
                      {t("Unit Cost")}
                    </span>
                  </>
                )}
                <span className="form-check-label" for="flexCheckDefault">
                  {/* Quantity */}
                  {t("Quantity")}
                </span>
              </div>
              <div
                className="under-Texts"
                style={{
                  justifyContent: !stockData?.enableStockManagement
                    ? "end"
                    : "space-around",
                  paddingRight: !stockData?.enableStockManagement ? "15px" : "",
                }}
              >
                {stockData?.enableStockManagement && (
                  <>
                    <span className="form-check-label" for="flexCheckDefault">
                      {stockData.qty *
                      productList?.stock?.unitCost
                        .toString()
                        .replace(/[, €]/g, "")
                        ? formattedCurrency(
                            stockData.qty *
                              productList?.stock?.unitCost
                                .toString()
                                .replace(/[, €]/g, ""),
                          )
                        : 0}
                    </span>
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* {productList?.productpartsuppliers[0]?.costprice
                        ? europeanFormatWithSymbol(
                            productList?.productpartsuppliers[0]?.costprice
                          )
                        : 0} */}

                      {/* {productList?.productpartsuppliers[0]?.costprice} */}
                      {productList?.stock?.unitCost}
                    </span>
                  </>
                )}
                <span className="form-check-label" for="flexCheckDefault">
                  <input
                    type="number"
                    className="products-and-parts-tab-dimensions-input"
                    value={stockData.qty}
                    placeholder="0"
                    onChange={(e) =>
                      setStockData((prevData) => ({
                        ...prevData,
                        qty: e.target.value,
                      }))
                    }
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div
          className="d-flex align-items-baseline justify-content-between px-3"
          style={{ borderBottom: "1px solid #8080806e" }}
        >
          <span className="product-stock-heading">
            {t("Purchasing History")}
          </span>
          <div className="products-and-parts-custom-pagination">
            <div className="range-text">
              {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex} of ${paginationObj.totalRecords}`}
            </div>
            <div className="products-and-parts-pagination-buttons">
              <div
                onClick={() =>
                  calculatePagination(paginationObj.currentPage - 1)
                }
                className={`products-and-parts-pagination-button ${
                  paginationObj.currentPage === 1 ? "disabled" : ""
                }`}
              >
                <BsChevronLeft />
              </div>
              <div className="pagination-current-page">
                {paginationObj.currentPage}
              </div>
              <div
                onClick={() =>
                  calculatePagination(paginationObj.currentPage + 1)
                }
                className={`products-and-parts-pagination-button ${
                  paginationObj.totalPages === 0 ||
                  paginationObj.totalPages === paginationObj.currentPage
                    ? "disabled"
                    : ""
                }`}
              >
                <BsChevronRight />
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between py-2 px-3"
          style={{ borderBottom: "1px solid #8080806e" }}
        >
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center gap-5">
              <span
                className="product-stock-heading"
                style={{ minWidth: "100px" }}
              >
                {t("P.Order ID")}
              </span>
              <span
                className="product-stock-heading"
                style={{ minWidth: "150px" }}
              >
                {t("Date")}
              </span>
              <span
                className="product-stock-heading"
                style={{ minWidth: "100px" }}
              >
                {t("Supplier")}
              </span>
            </div>
            <div className="d-flex align-items-center gap-5">
              <span
                className="product-stock-heading"
                style={{ minWidth: "100px" }}
              >
                {t("Unit Cost")}
              </span>
              <span
                className="product-stock-heading"
                style={{ minWidth: "100px" }}
              >
                {t("Qty")}
              </span>
            </div>
          </div>
        </div>
        {productionHistory.length > 0 && (
          <>
            {paginationObj?.records?.map((item, index) => (
              <div
                style={{ borderBottom: "1px dotted #8080806e" }}
                key={index}
                className="d-flex align-items-center justify-content-between  py-2  px-3"
              >
                <div className="d-flex align-items-center gap-5">
                  <span
                    className="product-stock-des"
                    style={{ minWidth: "100px" }}
                  >
                    {item.orderCode}
                  </span>
                  <span
                    className="product-stock-des"
                    style={{ minWidth: "150px" }}
                  >
                    {item.date.split("T")[0]}
                  </span>
                  <span
                    className="product-stock-des"
                    style={{ minWidth: "100px" }}
                  >
                    {item.supplier}
                  </span>
                </div>
                <div className="d-flex align-items-center gap-5">
                  <span
                    className="product-stock-des"
                    style={{ minWidth: "100px" }}
                  >
                    {item.unitCost
                      ? formattedCurrency(
                          parseFloat(
                            item.unitCost.toString().replace(",", "."),
                          ) || 0,
                        )
                      : 0}
                  </span>

                  <span
                    className="product-stock-des"
                    style={{ minWidth: "100px" }}
                  >
                    {item.qty}
                  </span>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default PartStock;
